import { global } from '../constants';

export const data = {
  banner: {
    background: global.banner + 'electronics.webp',
    title: 'Electronics',
    crumb: 'Industries / Electronics',
  },
  intro: {
    img: global.banner + 'diamond-2.webp',
    tagline: "TRUSTED BY THE WORLD'S FINEST",
    heading: 'Secure, Specialized Logistics for High-Value Goods',
    description:
      'With years of experience handling high-value goods, we offer trusted logistics solutions designed for the diamond and jewelry sector. From origin to destination, our secure chain of custody ensures your assets are protected every step of the way.',
  },
  whychoosus: {
    img: global.banner + 'electronics-2.png',
    title: 'RELIABLE ELECTRONICS LOGISTICS EXPERTS',
    subtitle: 'WHY CHOOSE US FOR ELECTRONICS',
    description:
      'We provide specialized logistics solutions for the electronics industry, ensuring safe, efficient, and timely movement of components, assemblies, and finished devices. Our expertise helps manufacturers and distributors maintain resilient supply chains and meet fast-paced market demands.',
    projects: '45+',
    specifications: [
      'Expert handling for fragile and high-value electronic components.',
      'Climate-controlled storage and transport for sensitive technologies.',
      'Streamlined delivery to support production and assembly lines.',
      'Efficient reverse logistics for returns, repairs, and refurbishments.',
      'Trusted by global electronics manufacturers, distributors, and technology providers.',
    ],
  },
  allservices: {
    main: 'Services',
    title: 'ALL SERVICES',
    subtitle: 'Trusted for Our Electronics Logistics Solutions',
    description:
      'Our specialized services are designed to keep electronics supply chains running smoothly, from sourcing components to delivering finished products worldwide.',
    services: [
      {
        serial: '01',
        title: 'Component Sourcing Logistics',
        description:
          'Reliable inbound logistics ensuring critical parts reach manufacturing on time.',
      },
      {
        serial: '02',
        title: 'Assembly Line Support',
        description:
          'Seamless delivery of components to production floors for uninterrupted workflows.',
      },
      {
        serial: '03',
        title: 'Sensitive Equipment Transport',
        description:
          'Specialized handling for fragile electronics and precision instruments.',
      },
      {
        serial: '04',
        title: 'Reverse Logistics',
        description:
          'Efficient solutions for returns, repairs, and refurbishment of electronics.',
      },
      {
        serial: '05',
        title: 'Inventory Management',
        description:
          'Kitting, staging, and storage designed to optimize electronic supply chains.',
      },
      {
        serial: '06',
        title: 'Aftermarket Distribution',
        description:
          'Timely delivery of replacement parts and accessories to end-users worldwide.',
      },
    ],
  },
};
